<template>
  <v-container class="device" fluid>
    <div class="device-header">
      <h1 class="device-header__title">{{ $route.meta.title }}</h1>
      <div class="device-header__actions">
        <v-menu
          v-if="$checkPermission('export_csv_device')"
          bottom
          left
          offset-y
          origin="bottom left"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              outlined
              class="device-header__btn text-none"
              dark
              rounded
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left>mdi-download</v-icon>
              Скачать отчёт
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="downloadReport()">
              <v-list-item-icon class="mr-2">
                <v-icon small>mdi-file-document-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Полный отчёт</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="downloadReportPage()">
              <v-list-item-icon class="mr-2">
                <v-icon small>mdi-file-table-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Отчёт на странице</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          v-if="$checkPermission('create_device')"
          color="primary"
          class="device-header__btn text-none"
          dark
          rounded
          to="/device/new"
        >
          <v-icon left>mdi-plus</v-icon>
          Новое устройство
        </v-btn>
      </div>
    </div>

    <v-card class="device-block mt-3" flat outlined>
      <div class="device-filters">
        <div class="device-filters__row">
          <div class="device-filters__main">
            <div class="device-filters__title">
              <v-icon left small>mdi-filter-variant</v-icon>
              Фильтры
            </div>
            <div class="filters-devices">
              <v-text-field
                v-model="filterIpAddress"
                @keyup.enter="filterDevices()"
                label="IP адрес"
                outlined
                dense
                hide-details
                prepend-inner-icon="mdi-ip-outline"
                class="device-filters__field"
              />
              <v-text-field
                v-model="filterSerialNumber"
                @keyup.enter="filterDevices()"
                label="Серийный номер"
                prepend-inner-icon="mdi-cog-outline"
                outlined
                dense
                hide-details
                class="device-filters__field"
              />
              <v-text-field
                v-model="filterMacAddress"
                @keyup.enter="filterDevices()"
                label="MAC адрес"
                prepend-inner-icon="mdi-access-point"
                outlined
                dense
                hide-details
                class="device-filters__field"
              />
              <v-autocomplete
                v-model="selectedModel"
                :items="filteredModels"
                placeholder="Модель устройства"
                item-text="text"
                item-value="value"
                prepend-inner-icon="mdi-cellphone"
                outlined
                dense
                hide-details
                clearable
                class="device-filters__field"
              />
              <div class="device-filters__search-wrap">
                <v-btn color="primary" class="text-none" dark rounded @click.prevent="filterDevices()">
                  <v-icon left>mdi-magnify</v-icon>
                  Поиск
                </v-btn>
              </div>
            </div>
            <div class="device-filters__switches">
                <v-switch
                  :disabled="filterBusyDevices"
                  v-model="filterFreeDevices"
                  @change="showFiltersDevices()"
                  hide-details
                  color="primary"
                  label="Свободные"
                  class="mt-0"
                />
                <v-switch
                  :disabled="filterFreeDevices"
                  v-model="filterBusyDevices"
                  @change="showFiltersDevices()"
                  hide-details
                  color="primary"
                  label="Занятые"
                  class="mt-0"
                />
                <v-switch
                  :disabled="filterGRZ"
                  v-model="filterDoorphone"
                  @change="showFiltersDevices()"
                  hide-details
                  color="primary"
                  label="Домофоны"
                  class="mt-0"
                />
                <v-switch
                  :disabled="filterDoorphone"
                  v-model="filterGRZ"
                  @change="showGRZDevices()"
                  hide-details
                  color="primary"
                  label="ГРЗ"
                  class="mt-0"
                />
            </div>
          </div>
        </div>
      </div>
      <v-divider class="my-0" />
      <v-data-table
        class="table"
        :headers="headersDevice"
        :items="devices"
        :options.sync="options"
        :server-items-length="totalDevices"
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 50, 100],
          showFirstLastPage: true
        }"
        disable-sort
      >
        <template v-slot:item.mac_address="{ item }">
          <span v-if="item.mac_address">{{ item.mac_address }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row justify="end" class="flex-nowrap">
            <template v-if="$checkPermission('view_device_logs')">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    text
                    small
                    v-bind="attrs"
                    v-on="on"
                    class="btn__icon mr-2"
                    width="18"
                    height="18"
                    @click.stop="$set(logDialog, item.id, true)"
                  >
                    <v-icon>mdi-math-log</v-icon>
                  </v-btn>
                </template>
                <span>Логи</span>
              </v-tooltip>
            </template>
            <v-dialog v-model="logDialog[item.id]" max-width="990">
              <logDevice
                :active.sync="logDialog[item.id]"
                @close="$set(logDialog, item.id, false)"
                :id="item.id"
                message="Логи устройства"/>
            </v-dialog>
            <template v-if="$checkPermission('view_device')">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  text
                  v-bind="attrs"
                  v-on="on"
                  small
                  class="btn__icon pa-0 mr-1"
                  width="18"
                  height="18"
                  @click.stop="$set(DetailDialog, item.id, true)"
                >
                  <v-icon size="large">mdi-information-slab-circle-outline</v-icon>
                </v-btn>
                  <v-dialog v-model="DetailDialog[item.id]" max-width="700">
                    <DetailDeviceModal
                      :active.sync="DetailDialog[item.id]"
                      @close="$set(DetailDialog, item.id, false)"
                      :device="item"/>
                  </v-dialog>
                </template>
                <span>Информация</span>
              </v-tooltip>
            </template>
            <template v-if="$checkPermission('update_device')">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    text
                    tile
                    v-bind="attrs"
                    v-on="on"
                    small
                    class="btn__icon pa-0 mr-1"
                    width="18"
                    height="18"
                    :to="`/device/${item.id}/edit`"
                  >
                    <v-icon size="large">mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Редактировать</span>
              </v-tooltip>
            </template>
            <template v-if="$checkPermission('destroy_device')">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click.stop="$set(dialog, item.id, true)"
                    icon
                    text
                    v-bind="attrs"
                    v-on="on"
                    tile
                    small
                    class="btn__icon pa-0 mr-1"
                    width="18"
                    height="18"
                  >
                    <v-icon size="large">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Удалить</span>
              </v-tooltip>
            </template>
            <v-dialog v-model="dialog[item.id]" max-width="400" content-class="dialog-border-radius">
              <baseDeleteModal
                :active.sync="dialog[item.id]"
                @close="$set(dialog, item.id, false)"
                @submit="removeDevice(item.id, item.type)"
                messageTitle="Удалить устройство?"
                messageText="Подтверждая, вы удалите устройство. Если устройство привязано к СКУД системе, удаление невозможно."
                confirmText="Удалить"
                cancelText="Отмена"
                confirmColor="error"
              />
            </v-dialog>
          </v-row>
        </template>
        <template v-slot:item.doorphone_address="{ item }">
          <span v-if="item.model_id === 8">Контроллер</span>
          <span v-if="item.model_id === 7">ГРЗ</span>
          <router-link v-if="item.type === 'G' && item.barrier" class="routerLink" :to="`/barrier/${item.barrier.id}`">
            <span>{{ `Шлагбаум №${item.barrier.id}` }}</span>
          </router-link>
          <span v-if="item.type === 'G' && !item.barrier">Не привязан</span>
          <router-link v-if="item.type !== 'G' && item.doorphone" class="routerLink" :to="`/doorphones/${item.doorphone.id}`">
            <span>{{ getDoorphoneAddress(item.doorphone) }}</span>
          </router-link>
          <span v-if="item.type !== 'G' && item.doorphone === null && item.model_id !== 7 && item.model_id !== 8">Не привязан</span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { DEFAULT_DATA_TABLE_OPTIONS } from '@/constants/data-table';
import watchTableOptions from '../mixins/watchTableOptions';
import logDevice from '../components/device/logDevice';
import DetailDeviceModal from '@/components/device/DetailDeviceModal';
import baseDeleteModal from '@/components/BaseDeleteModal';

export default {
  name: 'Devices',
  mixins: [watchTableOptions],
  components: { DetailDeviceModal, logDevice, baseDeleteModal },

  data () {
    return {
      isCreated: false,
      filterFreeDevices: false,
      filterBusyDevices: false,
      filterDoorphone: false,
      filterGRZ: false,
      disableLogs: false,
      DetailDialog: {},
      isDisplaySmall: true,
      disableFilterName: false,
      dialog: {},
      logDialog: {},
      options: DEFAULT_DATA_TABLE_OPTIONS,
      sort: '',
      filters: {},
      filterIpAddress: '',
      filterMacAddress: '',
      filterSerialNumber: '',
      selectedModel: null,
      filteredModels: [
        { text: 'Rubetek (RV-3434)', value: 'RV-3434' },
        { text: 'Rubetek (RV-3438)', value: 'RV-3438' },
        { text: 'Rubetek (RACS-1101)', value: 'RACS-1101' },
        { text: 'Beward (DKS-1512)', value: 'DKS1512' },
        { text: 'Beward (DKS-15134)', value: 'DKS15134' },
        { text: 'Beward (DKS-20210)', value: 'DKS20210' },
        { text: 'Beward (DKS-20211)', value: 'DKS20211' },
        { text: 'Beward (DS07P-LP)', value: 'DS07P-LP' },
        { text: 'Akuvox', value: 'E12' },
        { text: 'Ufanet (Secret-Top)', value: 'Secret-Top' },
        { text: 'ISCom (Sokol-Plus)', value: 'Sokol-Plus' },
        { text: 'GSM Модуль', value: 'gsm' },
      ],
      headersDevice: [
        { text: 'id', value: 'id' },
        { text: 'ip-адрес', value: 'ip_address' },
        { text: 'Серийный номер', value: 'serial_number' },
        { text: 'Агент', value: 'agent.user.name', width: '10%' },
        { text: 'MAC-адрес', value: 'mac_address' },
        { text: 'Производитель устройства', value: 'manufacturer' },
        { text: 'Модель', value: 'model', width: '8%' },
        { text: 'Домофон', value: 'doorphone_address' },
        { text: '', value: 'actions' },
      ],
      totalDevices: 0,
    };
  },
  created () {
    this.isCreated = true;
    this.loadDevices();
    switch (this.roleName) {
      case 'admin':
        this.disableLogs = true;
        break;
    }
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
  },
  computed: {
    ...mapGetters({
      devices: 'Device/devices',
      roleName: 'roleName',
      loading: 'loading',
    }),
  },
  methods: {
    ...mapActions({
      getDevices: 'Device/getDevices',
      deleteDevice: 'Device/deleteDevice',
      deleteDeviceGsm: 'Device/deleteDeviceGsm',
      exportCsv: 'Device/exportCsv',
    }),
    checkSize () {
      this.isDisplaySmall = window.innerWidth >= 600;
    },
    removeDevice (id, type) {
      const deleteAction = type === 'G' ? this.deleteDeviceGsm(id) : this.deleteDevice(id);
      deleteAction
        .then(() => {
          this.$flash_success('Устройство успешно удалено');
          this.loadDevices();
        })
        .catch(() => {
          this.$flash_warning('Ошибка при удалении устройства');
        });
      this.dialog[id] = false;
    },
    newDevice () {
      this.$router.push({ name: 'NewDevice' });
    },
    downloadReport () {
      this.exportCsv()
        .then((response) => {
          const data = new Blob([response], { type: 'application/csv' });
          const a = document.createElement('a');
          a.download = 'devices.csv';
          a.href = URL.createObjectURL(data);
          a.click();
        })
        .catch((e) => {
          this.$flash_warning('Ошибка при скачивании отчёта');
        });
    },
    getDoorphoneAddress (doorphone) {
      let address = doorphone.address;
      if (doorphone.type === 'G') {
        address += ', (калитка)';
      }
      if (doorphone.entrance > 0) {
        address = `${doorphone.address}, п.${doorphone.entrance}`;
        if (doorphone.type === 'A') {
          address += ', (доп.вход)';
        }
      }
      return address;
    },
    encodeCP1251 (string) {
      function encodeChar (c) {
        const isKyr = function (str) {
          return /[а-я]/i.test(str);
        };
        // eslint-disable-next-line no-multi-str
        const cp1251 = 'ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬*®Ї°±Ііґµ¶·\
ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя';
        const p = isKyr(c) ? (cp1251.indexOf(c) + 128) : c.charCodeAt(0);
        let h = p.toString(16);
        if (h === 'a') {
          h = '0A';
        }
        return '%' + h;
      }
      let res = '';
      for (let i = 0; i < string.length; i++) {
        res += encodeChar(string.charAt(i));
      }
      return res;
    },
    downloadReportPage () {
      const lines = [];
      this.devices.forEach((item) => {
        let doorphoneAddress;
        if (item.doorphone) {
          doorphoneAddress = this.getDoorphoneAddress(item.doorphone);
        }
        if (item.doorphone === null && item.model_id !== 7) {
          doorphoneAddress = 'Не привязан';
        }
        if (item.model_id === 7) {
          doorphoneAddress = '-';
        }
        const line = [
          item.id, item.ip_address, item.serial_number, item.agent.user.name,
          item.mac_address, item.manufacturer, item.model, doorphoneAddress,
        ].join(';');
        lines.push(line);
      });
      const link = document.createElement('a');
      link.href = `data:text/csv;charset=CP1251,${this.encodeCP1251(lines.join('\n'))}`;
      link.download = 'device-page.csv';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    filterDevices () {
      this.options.page = 1;
      this.filters = {};

      if (this.filterIpAddress) {
        this.filters.ip_address = this.filterIpAddress;
      }

      if (this.filterMacAddress) {
        this.filters.mac_address = this.filterMacAddress;
      }

      if (this.filterSerialNumber) {
        this.filters.serial_number = this.filterSerialNumber;
      }

      if (this.selectedModel) {
        this.filters['model.name'] = this.selectedModel;
      }

      if (this.filterFreeDevices) {
        this.filters.free = '1';
      } else {
        delete this.filters.free;
      }

      if (this.filterBusyDevices) {
        this.filters.busy = '1';
      } else {
        delete this.filters.busy;
      }

      if (this.filterDoorphone) {
        this.filters.type = 'D';
      } else {
        delete this.filters.type;
      }

      this.loadDevices();
    },
    showFiltersDevices () {
      this.options.page = 1;
      this.filterDevices();
    },
    showGRZDevices () {
      this.options.page = 1;
      if (this.filterGRZ) {
        this.filters.type = 'B';
      } else {
        delete this.filters.type;
      }

      this.loadDevices();
    },
    loadDevices () {
      this.getDevices({
        pagination: 1,
        page: this.options.page,
        limit: this.options.itemsPerPage,
        filters: this.filters,
        include: 'doorphone,barrier',
        sort: this.sort,
      })
        .then((response) => {
          this.totalDevices = response.meta.total;
        })
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке устройств');
        });
    },
  },
  watch: {
    options (curr, prev) {
      this.handleOptionsChange(curr, prev, () => {
        this.loadDevices();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.device-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px 0;
}

.device-header__title {
  font-size: 1.5rem;
  font-weight: 400;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.02em;
}

.device-header__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.device-header__btn {
  text-transform: none;
  font-weight: 500;
}

.device-block {
  border-radius: 12px;
  overflow: hidden;
}

.device-filters {
  padding: 10px 16px 8px;
}

.device-filters__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
}

.device-filters__main {
  flex: 1;
  min-width: 0;
}

.device-filters__title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #546e7a;
  padding: 0 0 6px 0;
  margin: 0;
  display: flex;
  align-items: center;
}

.device-filters__field {
  max-width: 280px;
  width: 100%;
}

.device-filters__search-wrap {
  display: flex;
  align-items: center;
}

.device-filters__switches {
  display: flex;
  flex-wrap: wrap;
  gap: 30px 34px;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

.device-switch-card {
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  padding: 2px 10px 2px 4px;
  transition: border-color 0.2s, background-color 0.2s;

  &--active {
    border-color: rgba(90, 138, 93, 0.5);
    background: rgba(90, 138, 93, 0.08);
  }
}

.filters-devices {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: auto;
  grid-row-gap: 4px;
  grid-column-gap: 10px;
  grid-auto-rows: auto;
  align-items: start;
}

.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}

@media screen and (max-width: 900px) {
  .filters-devices {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media screen and (max-width: 600px) {
  .device-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .device-header__title {
    font-size: 1.4rem;
  }

  .filters-devices {
    display: block;
    grid-template-columns: 1fr;
  }

  .device-filters__field {
    max-width: none;
  }

  .device-filters__search-wrap {
    margin-bottom: 8px;
  }

  .device-filters__switches {
    margin-top: 4px;
  }
}
</style>
